const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"feArrowDown0\" fill=\"none\" fill-rule=\"evenodd\" stroke=\"none\" stroke-width=\"1\"><g id=\"feArrowDown1\" fill=\"currentColor\"><path id=\"feArrowDown2\" d=\"m6 7l6 6l6-6l2 2l-8 8l-8-8z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
